import { useRouter } from 'next/router';

// Lib
import {
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES,
    NO_ACTIVE_SOCIAL_PROFILE,
    INTEGRATIONS
} from '@/lib/routes/privateRoutes';

// Hooks
import useSocialProfiles from '@/hooks/swr/useSocialProfiles';

// Components
import LoaderPage from '@/components/base/Loader/LoaderPage';

const URLS_WITHOUT_SOCIAL_PROFILE = [
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    INTEGRATIONS,
    THEMES,
    SECURITY,
    SUBSCRIPTION,
    SUBSCRIPTION_INVOICES,
    USERS_ROLES,
    SOCIAL_PROFILES,
    NO_ACTIVE_SOCIAL_PROFILE
];

const HasSocialProfileMiddleware = ({ children }) => {
    const router = useRouter();
    const urlWithoutParams = router.pathname.split('?')[0];
    const { activatedSocialProfiles } = useSocialProfiles({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });
    router.prefetch(NO_ACTIVE_SOCIAL_PROFILE);

    if (
        !activatedSocialProfiles?.length &&
        !URLS_WITHOUT_SOCIAL_PROFILE.includes(urlWithoutParams)
    ) {
        router.push(NO_ACTIVE_SOCIAL_PROFILE);
        return <LoaderPage />;
    }

    return children;
};

export default HasSocialProfileMiddleware;
